'use strict';// Public API for Zone
var ng_zone_1 = require('./zone/ng_zone');
exports.NgZone = ng_zone_1.NgZone;
exports.NgZoneError = ng_zone_1.NgZoneError;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiem9uZS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImFuZ3VsYXIyL3NyYy9jb3JlL3pvbmUudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsc0JBQXNCO0FBQ3RCLHdCQUFvRSxnQkFBZ0IsQ0FBQztBQUE3RSxrQ0FBTTtBQUFvQyw0Q0FBbUMiLCJzb3VyY2VzQ29udGVudCI6WyIvLyBQdWJsaWMgQVBJIGZvciBab25lXG5leHBvcnQge05nWm9uZSwgWmVyb0FyZ0Z1bmN0aW9uLCBFcnJvckhhbmRsaW5nRm4sIE5nWm9uZUVycm9yfSBmcm9tICcuL3pvbmUvbmdfem9uZSc7XG4iXX0=


/*****************
 ** WEBPACK FOOTER
 ** ./~/angular2/src/core/zone.js
 ** module id = 283
 ** module chunks = 1
 **/